window.paoMoney = cents => { const n = Math.round(Number(cents) || 0); return Math.floor(n / 100) + ',' + String(n % 100).padStart(2, '0') + ' DH'; };
(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  const menu = document.querySelector('.mobile-menu-panel');
  const menuOverlay = document.querySelector('[data-menu-overlay]');
  let lastFocus = null;
  let menuLastFocus = null;
  const root = window.Shopify?.routes?.root || '/';
  const money = window.paoMoney;
  const threshold = Number(getComputedStyle(document.documentElement).getPropertyValue('--free-shipping')) || 49900;
  async function request(path, options) {
    const response = await fetch(root + path, {credentials:'same-origin', ...options});
    const data = await response.json().catch(() => ({}));
    if (!response.ok) { const err = new Error(data.description || data.message || 'Cart request failed'); err.data = data; throw err; }
    return data;
  }
  function node(tag, className, text) {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text != null) el.textContent = text;
    return el;
  }
  function notice(msg) {
    const target = document.querySelector('[data-cart-items]');
    if (!target) { alert(msg); return; }
    target.querySelector('.cart-notice')?.remove();
    const n = node('div','cart-notice',msg); n.setAttribute('role','alert'); target.prepend(n);
  }
  async function refreshCart() {
    const cart = await request('cart.js');
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    document.querySelector('[data-drawer-count]').textContent = `(${cart.item_count})`;
    document.querySelector('[data-cart-subtotal]').textContent = money(cart.total_price);
    const left = Math.max(0, threshold - cart.total_price);
    document.querySelector('[data-shipping-message]').textContent = left ? `Encore ${money(left)} pour la livraison offerte` : 'Livraison offerte : seuil atteint ✦';
    document.querySelector('[data-shipping-progress]').style.width = `${Math.min(100, cart.total_price / threshold * 100)}%`;
    const target = document.querySelector('[data-cart-items]');
    target.replaceChildren();
    if (!cart.items.length) { target.append(node('div','empty','Votre panier est vide.')); return; }
    cart.items.forEach(item => {
      const line = node('div','line-item');
      if (item.image) { const img = node('img','thumb'); img.src = item.image; img.alt = ''; img.loading = 'lazy'; line.append(img); }
      const detail = node('div','line-detail');
      detail.append(node('small','',item.vendor), node('b','',item.product_title));
      if (item.variant_title && item.variant_title !== 'Default Title') detail.append(node('small','',item.variant_title));
      detail.append(node('div','item-price',money(item.final_line_price)));
      const actions = node('div','line-actions'); const qty = node('div','qty');
      const minus = node('button','', '−'); minus.type = 'button'; minus.dataset.cartKey = item.key; minus.dataset.quantity = item.quantity - 1; minus.setAttribute('aria-label','Diminuer la quantité : ' + item.product_title);
      const plus = node('button','', '+'); plus.type = 'button'; plus.dataset.cartKey = item.key; plus.dataset.quantity = item.quantity + 1; plus.setAttribute('aria-label','Augmenter la quantité : ' + item.product_title);
      qty.append(minus,node('span','',item.quantity),plus);
      const remove = node('button','remove','Supprimer'); remove.type = 'button'; remove.dataset.cartKey = item.key; remove.dataset.quantity = '0';
      actions.append(qty, remove); detail.append(actions); line.append(detail); target.append(line);
    });
  }
  async function openCart(trigger) {
    if (menu?.classList.contains('open')) closeMenu(false);
    lastFocus = trigger || document.activeElement;
    overlay.hidden = false; drawer.classList.add('open'); drawer.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden'; drawer.querySelector('[data-cart-close]').focus();
    try { await refreshCart(); } catch(e) { document.querySelector('[data-cart-items]').textContent = 'Impossible de charger le panier.'; }
  }
  function closeCart() {
    drawer.classList.remove('open'); drawer.setAttribute('aria-hidden','true'); overlay.hidden = true;
    document.body.style.overflow = ''; lastFocus?.focus?.();
  }
  function openMenu(trigger) {
    if (!menu) return;
    if (drawer.classList.contains('open')) closeCart();
    menuLastFocus = trigger || document.activeElement;
    menuOverlay.hidden = false;
    menu.classList.add('open');
    menu.setAttribute('aria-hidden','false');
    document.querySelectorAll('[data-menu-open]').forEach(button => button.setAttribute('aria-expanded','true'));
    document.body.style.overflow = 'hidden';
    menu.querySelector('[data-menu-close]').focus();
  }
  function closeMenu(restoreFocus = true) {
    if (!menu) return;
    menu.classList.remove('open');
    menu.setAttribute('aria-hidden','true');
    menuOverlay.hidden = true;
    document.querySelectorAll('[data-menu-open]').forEach(button => button.setAttribute('aria-expanded','false'));
    document.body.style.overflow = '';
    if (restoreFocus) menuLastFocus?.focus?.();
  }
  document.addEventListener('click', async event => {
    const menuOpen = event.target.closest('[data-menu-open]');
    if (menuOpen) { openMenu(menuOpen); return; }
    if (event.target.closest('[data-menu-close]') || event.target === menuOverlay) { closeMenu(); return; }
    if (event.target.closest('.mobile-menu-links a')) { closeMenu(false); return; }
    if (event.target.closest('[data-search-focus]')) {
      closeMenu(false);
      const search = document.querySelector('#HeaderSearch');
      search?.scrollIntoView({behavior:'smooth',block:'center'});
      search?.focus();
      return;
    }
    const open = event.target.closest('[data-cart-open]');
    if (open) { openCart(open); return; }
    if (event.target.closest('[data-cart-close]') || event.target === overlay) { closeCart(); return; }
    const change = event.target.closest('[data-cart-key]');
    if (change) {
      change.disabled = true;
      try { await request('cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:change.dataset.cartKey,quantity:Number(change.dataset.quantity)})}); await refreshCart(); }
      catch(e) { change.disabled = false; await refreshCart().catch(()=>{}); notice(e.message && e.message !== 'Cart request failed' ? e.message : 'Quantité indisponible : stock insuffisant.'); }
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-ajax-add], .product-form');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type=submit]'); button.disabled = true;
    try { await request('cart/add.js',{method:'POST',body:new FormData(form)}); await openCart(button); }
    catch(e) { await openCart(button); notice(e.data?.description || 'Ce produit n’a pas pu être ajouté : stock insuffisant.'); }
    finally { button.disabled = false; }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      if (menu?.classList.contains('open')) closeMenu();
      else if (drawer.classList.contains('open')) closeCart();
    }
    if (event.key === 'Tab' && menu?.classList.contains('open')) {
      const focusable = [...menu.querySelectorAll('a,button,summary')].filter(el => el.getClientRects().length);
      const first = focusable[0], last = focusable.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
    if (event.key === 'Tab' && drawer.classList.contains('open')) {
      const focusable = [...drawer.querySelectorAll('a,button,input,select')].filter(el => !el.disabled);
      const first = focusable[0], last = focusable.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  window.addEventListener('resize', () => { if (window.innerWidth > 650 && menu?.classList.contains('open')) closeMenu(false); });
  function initSlider(slider) {
    const slides = [...slider.querySelectorAll('[data-slide]')];
    if (!slides.length) return;
    const dots = [...slider.querySelectorAll('[data-go-slide]')];
    let current = 0, timer = null, cleanup = null, userPaused = false;
    const viewport = slider.querySelector('.hero-slides');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const duration = Math.max(3000, Number(slider.dataset.interval) || 5000);
    const autoplay = slider.dataset.autoplay === 'true' && slides.length > 1;
    const toggle = slider.querySelector('[data-slide-toggle]');
    function fit() { viewport.style.height = `${slides[current].scrollHeight}px`; }
    function pause() { if (timer) clearInterval(timer); timer = null; }
    function play() {
      pause();
      if (autoplay && !userPaused && !reducedMotion.matches && !document.hidden && !slider.matches(':hover') && !slider.contains(document.activeElement)) timer = setInterval(() => show(current + 1, 1), duration);
    }
    function show(index, direction) {
      const next = (index + slides.length) % slides.length;
      if (next === current) return;
      if (cleanup) clearTimeout(cleanup);
      slides.forEach(slide => slide.classList.remove('is-leaving'));
      const previous = slides[current];
      slider.dataset.direction = direction < 0 ? 'backward' : 'forward';
      previous.classList.add('is-leaving');
      previous.classList.remove('is-active');
      previous.setAttribute('aria-hidden','true');
      previous.querySelectorAll('a,button').forEach(el => el.setAttribute('tabindex','-1'));
      current = next;
      const active = slides[current];
      active.querySelectorAll('img[loading=lazy]').forEach(img => img.loading = 'eager');
      active.classList.add('is-active');
      active.setAttribute('aria-hidden','false');
      active.querySelectorAll('a,button').forEach(el => el.removeAttribute('tabindex'));
      dots.forEach((dot,i) => dot.setAttribute('aria-current',String(i===current)));
      fit();
      cleanup = setTimeout(() => previous.classList.remove('is-leaving'), 600);
    }
    if (toggle) {
      if (reducedMotion.matches) { userPaused = true; toggle.classList.add('is-paused'); toggle.setAttribute('aria-pressed','true'); toggle.setAttribute('aria-label','Reprendre le défilement'); }
      toggle.addEventListener('click', () => {
        userPaused = !userPaused;
        toggle.classList.toggle('is-paused', userPaused);
        toggle.setAttribute('aria-pressed', String(userPaused));
        toggle.setAttribute('aria-label', userPaused ? 'Reprendre le défilement' : 'Mettre en pause le défilement');
        if (userPaused) pause(); else { timer = setInterval(() => show(current + 1, 1), duration); }
      });
    }
    slider.querySelector('[data-slide-prev]')?.addEventListener('click',() => { show(current-1,-1); play(); });
    slider.querySelector('[data-slide-next]')?.addEventListener('click',() => { show(current+1,1); play(); });
    dots.forEach((dot,i) => dot.addEventListener('click',() => { show(i,i<current?-1:1); play(); }));
    let start = null;
    slider.addEventListener('touchstart', e => {start=e.changedTouches[0].screenX},{passive:true});
    slider.addEventListener('touchend', e => {if(start == null)return; const dx=e.changedTouches[0].screenX-start; start=null; if(Math.abs(dx)>55){ show(current+(dx<0?1:-1),dx<0?1:-1); play(); }},{passive:true});
    slides.forEach((slide,i) => { slide.setAttribute('aria-hidden',String(i!==0)); if(i) slide.querySelectorAll('a,button').forEach(el => el.setAttribute('tabindex','-1')); });
    slider.classList.add('is-ready');
    fit();
    slider.querySelectorAll('img').forEach(img => img.addEventListener('load',fit));
    window.addEventListener('resize',fit);
    window.addEventListener('load', () => { const n = slides[1]; n && n.querySelectorAll('img[loading=lazy]').forEach(img => img.loading = 'eager'); });
    slider.addEventListener('mouseenter',pause);
    slider.addEventListener('mouseleave',play);
    slider.addEventListener('focusin',pause);
    slider.addEventListener('focusout',event => { if(!slider.contains(event.relatedTarget)) play(); });
    document.addEventListener('visibilitychange',() => document.hidden ? pause() : play());
    reducedMotion.addEventListener('change',play);
    play();
  }
  document.querySelectorAll('[data-slider]').forEach(initSlider);
  document.addEventListener('shopify:section:load',e => e.target.querySelectorAll('[data-slider]').forEach(initSlider));
})();